import React from 'react';

import { Outlet } from "react-router-dom";

class AppExt extends React.Component {

  render() {
    return <div className='AppExt'>
      <Outlet />
    </div>;
  }
}

export default AppExt;